import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ui-accordion',
  template: `<div class="accordion" id="accordionExample">
  <ng-content></ng-content>
</div>
`,
  styles: [``]
})
export class AccordionComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }


}
